import i18n from "./i18n";

// Validation messages in the viewer's language (they were Russian for everyone).
export const ERROR_MESSAGES = {
  REQUIRED: ["widget.common.validation.required", "Please fill in this field"],
  PHONE_INVALID: ["widget.common.validation.phone_invalid", "This phone number looks incomplete — please check it"],
  SERVICE_REQUIRED: ["appointment.status.select_service", "Select service"],
} as const;

export type ErrorMessageKey = keyof typeof ERROR_MESSAGES;

export function getErrorMessage(code?: ErrorMessageKey): string | undefined {
  if (!code) return undefined;
  const [key, fallback] = ERROR_MESSAGES[code];
  return i18n.t(key, fallback);
}
